import React, { ReactNode } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TransitionProps } from "@mui/material/transitions";
import Button from "../../components/Button/Button";
import Successful from '../../assets/images/successful.svg';

interface SuccessDialogProps {
  open?: boolean;
  loading?: boolean;
  summary: string | ReactNode;
  onClose?: () => void;
  onConfirm?: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SuccessDialog: React.FC<SuccessDialogProps> = ({
  open = false,
  loading = false,
  onClose,
  onConfirm,
  summary,
}) => {
  return (
    <Dialog
      maxWidth={"sm"}
      fullWidth
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          overflow: "visible",
          borderRadius: "15px",
        },
      }}
    >
      <DialogTitle
        sx={{
          position: "relative",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: "-20px",
            top: "-20px",
            height: "44px",
            width: "44px",
            color: "#FB8B0E",
            border: "2px solid #FB8B0E",
            borderRadius: "50% !important",
            padding: 0,
            backgroundColor: "#fff",
            zIndex: 1000,
          }}
          disableRipple
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          maxHeight: "200px",
          textAlign: "center"
        }}
      >
        <img src={Successful} alt="success" />
        <DialogContentText
          sx={{
            marginTop: "1rem",
            color: "#000000",
            fontSize: "1.5em",
          }}
        >
          {summary}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          padding: "1.5rem",
           justifyContent: "center"
        }}
      >
        <Button
          isLoading={loading}
          onClick={onConfirm}
          variant="secondary"
          variantType="contained"
          label="Continue"
        />
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
